<template lang="pug" src="./block-row.pug"></template>

<script>
export default {
  props: ['props']
}
</script>



// WEBPACK FOOTER //
// block-row.vue?0bcecbcc